// extracted by mini-css-extract-plugin
module.exports = {"anonymous-panel":"AnonymousPanel_anonymous-panel__1eBPW","logo":"AnonymousPanel_logo__1B4kj","welcome-to":"AnonymousPanel_welcome-to__eeTcf"};